import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { ProductDetail } from './pages/product-detail/product-detail';
import { Register } from './pages/register/register';
import { Login } from './pages/login/login';
import { Profile } from './pages/profile/profile';
import { Cart } from './pages/cart/cart';
import { Checkout } from './pages/checkout/checkout';
import { OrderHistory } from './pages/order-history/order-history';
import { ContactUsComponent } from './pages/contact-us/contact-us';
import { AboutUsComponent } from './pages/about-us/about-us';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';
import { AdminGuard } from './guards/admin.guard';
import { AdminLayoutComponent } from './components/admin/admin-layout/admin-layout';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard';
import { AdminLoginComponent } from './components/admin/admin-login/admin-login';
import { OrderManagementComponent } from './components/admin/order-management/order-management.component';
import { OrderDetailComponent } from './components/admin/order-detail/order-detail.component';
import { ProductManagementComponent } from './components/admin/product-management/product-management.component';
import { CategoryManagementComponent } from './components/admin/category-management/category-management.component';
import { UserManagementComponent } from './components/admin/user-management/user-management.component';
import { AdminSiteContentComponent } from './components/admin/site-content/site-content';
import { ReportsComponent } from './components/admin/reports/reports.component';
import { SupportPreloginComponent } from './pages/support-prelogin/support-prelogin';
import { PaymentStatus } from './pages/payment-status/payment-status';

export const routes: Routes = [
  // Default route - show home publicly
  { 
    path: '', 
    component: Home,
    title: 'Dr. Piyu`s Height Clinic - Premium Growth Supplements',
    data: { animation: 'HomePage' }
  },
  // Public home alias
  { 
    path: 'home', 
    component: Home,
    title: 'Dr. Piyu`s Height Clinic - Premium Growth Supplements',
    data: { animation: 'HomePage' }
  },
  { 
    path: 'products', 
    component: Home,
    title: 'Products - Dr. Piyu`s Height Clinic'
  },
  { 
    path: 'product/:id', 
    component: ProductDetail,
    title: 'Product Details - Dr. Piyu`s Height Clinic'
  },
  
  // Product filtering routes
  {
    path: 'products/dose/:doseType',
    component: Home,
    title: 'Product Details - Dr. Piyu`s Height Clinic'
  },
  {
    path: 'products/dose-number/:doseNumber',
    component: Home,
    title: 'Product Details - Dr. Piyu`s Height Clinic'
  },

  // Guest only routes (redirect if already logged in)
  { 
    path: 'register', 
    component: Register,
    canActivate: [GuestGuard],
    title: 'Register - Dr. Piyu`s Height Clinic',
    data: { animation: 'RegisterPage' }
  },
  { 
    path: 'login', 
    component: Login,
    canActivate: [GuestGuard],
    title: 'Login - Dr. Piyu`s Height Clinic',
    data: { animation: 'LoginPage' }
  },
  { 
    path: 'support', 
    component: SupportPreloginComponent,
    canActivate: [GuestGuard],
    title: 'Support - Dr. Piyu`s Height Clinic',
    data: { animation: 'SupportPage' }
  },

  // Protected routes (require authentication)
  { 
    path: 'profile', 
    component: Profile,
    canActivate: [AuthGuard],
    title: 'My Profile - Dr. Piyu`s Height Clinic',
    data: { animation: 'ProfilePage' }
  },
  { 
    path: 'cart', 
    component: Cart,
    title: 'Shopping Cart - Dr. Piyu`s Height Clinic',
    data: { animation: 'CartPage' }
  },
  { 
    path: 'checkout', 
    component: Checkout,
    canActivate: [AuthGuard],
    title: 'Checkout - Dr. Piyu`s Height Clinic'
  },
  
  // Payment status route
  { 
    path: 'payment-status', 
    component: PaymentStatus,
    canActivate: [AuthGuard],
    title: 'Payment Status - Dr. Piyu`s Height Clinic'
  },

  // Order routes
  { 
    path: 'orders', 
    component: OrderHistory,
    canActivate: [AuthGuard],
    title: 'Order History - Dr. Piyu`s Height Clinic'
  },
  
  // Admin routes
  { 
    path: 'admin/login', 
    component: AdminLoginComponent,
    title: 'Admin Login - Dr. Piyu`s Height Clinic'
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'site-content',
        component: AdminSiteContentComponent,
        title: 'Site Content - Dr. Piyu`s Height Clinic'
      },
      {
        path: 'dashboard',
        component: AdminDashboardComponent,
        title: 'Admin Dashboard - Dr. Piyu`s Height Clinic'
      },
      {
        path: 'orders',
        component: OrderManagementComponent,
        title: 'Order Management - Dr. Piyu`s Height Clinic'
      },
      {
        path: 'orders/:id',
        component: OrderDetailComponent,
        title: 'Order Details - Dr. Piyu`s Height Clinic'
      },
      {
        path: 'products',
        component: ProductManagementComponent,
        title: 'Product Management - Dr. Piyu`s Height Clinic'
      },
      {
        path: 'categories',
        component: CategoryManagementComponent,
        title: 'Category Management - Dr. Piyu`s Height Clinic'
      },
      {
        path: 'users',
        component: UserManagementComponent,
        title: 'User Management - Dr. Piyu`s Height Clinic'
      },
      {
        path: 'reports',
        component: ReportsComponent,
        title: 'Reports - Dr. Piyu`s Height Clinic'
      }
    ]
  },
  
  // Additional routes
  { 
    path: 'contact', 
    component: ContactUsComponent,
    title: 'Contact Us - Dr. Piyu`s Height Clinic'
  },
  { 
    path: 'about', 
    component: AboutUsComponent,
    title: 'About Us - Dr. Piyu`s Height Clinic'
  },
  
  // Catch all route
  { 
    path: '**', 
    redirectTo: '/home',
    pathMatch: 'full'
  }
];
